import axios from 'axios';

export const state = () => ({
    ENTITY_GROUP_TYPE: 4
});

export const getters = {
    ENTITY_GROUP_TYPE: state => state.ENTITY_GROUP_TYPE
};

export const mutations = {};

export const actions = {
    index(vuexContext, businessProfileId) {
        return axios.$get('/v1/admin/rules', {
            params: { business_profile_id: businessProfileId }
        });
    },

    store(vuexContext, data) {
        const {
            name,
            entities,
            query,
            excludeQuery,
            ruleType,
            statusType,
            identities,
            labelIds,
            businessProfileId
        } = data;

        const payload = {
            business_profile_id: parseInt(businessProfileId),
            name,
            entities: entities.map(({ entityId, entityType }) => ({
                entity_id: entityId,
                entity_type: entityType
            })),
            query,
            exclude_query: excludeQuery,
            rule_type: ruleType,
            status_type: statusType,
            identities,
            label_ids: labelIds
        };

        return axios.$post('/v1/admin/rules', payload);
    },

    update(vuexContext, data) {
        const {
            id,
            name,
            entities,
            query,
            excludeQuery,
            ruleType,
            statusType,
            identities,
            labelIds,
            businessProfileId
        } = data;

        const payload = {
            name,
            entities: entities.map(({ entityId, entityType }) => ({
                entity_id: entityId,
                entity_type: entityType
            })),
            query,
            exclude_query: excludeQuery,
            rule_type: ruleType,
            status_type: statusType,
            identities,
            label_ids: labelIds
        };

        return axios.$patch(`/v1/admin/rules/${id}`, payload, {
            params: { business_profile_id: businessProfileId }
        });
    },

    destroy(vuexContext, { id, businessProfileId }) {
        return axios.$delete(`/v1/admin/rules/${id}`, {
            params: { business_profile_id: businessProfileId }
        });
    }
};
